//--------------------------------------------------------------------------------------------------Imports

import { Col } from "antd";
import { ResponsePackageItem } from "../../../types/common";
import MarkdownPreviewer from "../../../common/MarkdownPreviewer";

//-------------------------------------------------------------------------------------------------- Interface
interface WaitingServicesComponentProps {
    packageSrv: ResponsePackageItem,
};

//-------------------------------------------------------------------------------------------------- Component
const WaitingServicesComponent = (props: WaitingServicesComponentProps) => {
    const { packageSrv: pkg } = props;

    return (
        <Col span={24}>
            <MarkdownPreviewer
                h1Style={{
                    fontSize: 15,
                    color: "#000000",
                    fontWeight: 500
                }}
                h2Style={{
                    fontSize: 12,
                    color: "#707070",
                    fontWeight: 500
                }}
                h3Style={{
                    fontSize: 12,
                    color: "#000000",
                    margin: 0,
                    padding: 0,
                    fontWeight: 500
                }}
                h4Style={{
                    fontSize: 12,
                    color: "#000000",
                    margin: 0,
                    padding: 0,
                    fontWeight: 500
                }}
                textStyle={{
                    fontSize: 10,
                    color: "#000000",
                    margin: 0,
                    padding: 0,
                }}
                linkStyle={{
                    fontSize: 12,
                    color: "#000000",
                    textDecoration: "underline",
                }}
                mdSource={pkg.onProcessButton.mdContent}
            />
        </Col>
    );
};

//-------------------------------------------------------------------------------------------------- Exports
export default WaitingServicesComponent;
